// extracted by mini-css-extract-plugin
export default {"notification-stack":"dcd602"};